import styled from "styled-components";
 
export const Container = styled.div`
    display: flex;
    .link-button{
        text-decoration: none;
        font-weight: bold;
        border: 2px solid #1485c7;
        border-radius: 20px;
        color: #000;
        padding: 10px;
        :hover{
            background-color: #1485c7;
            color: white;
            transition: all 0.5s;
            border: 2px solid transparent;
        }
    }
`